/* eslint-disable */
import React, { Component } from "react";
import PropTypes from "prop-types";
import { defineMessages, FormattedMessage } from "react-intl";
import WidthWrapper from "./WidthWrapper";
import { Amount, BookableErrorMessage, Thumbnail } from "~/components";
import styled from "styled-components";
import classnames from "classnames";
import styles from "./EntityCarousel.scss";
import constants from "../../utils/constants";
import { filterDisplayElement, renderHTML } from "../../utils/misc";
import Slider from "react-slick";
import { NavigateBeforeIcon, NavigateNextIcon } from "../../theme/assets";
import media from "../../utils/media";
import { ArrowContainer } from "../../utils/ArrowContainer";
import Notification from "../Notification/Notification";
import { Tier } from "@witbooking/react-components";

const NavArrow = styled.div`
  svg {
    fill: white;
  }
`;

const DescriptionContainer = styled.div`
  @media only screen and (min-width: 1280px) and (max-width: 1366px) {
    display: none !important;
  }
`;

const InfoWrapper = styled.div`
  @media only screen and (min-width: 500px) {
    display: flex !important;
    flex-direction: column;
    justify-content: ${props => (props.showDisplayElements ? "space-between" : "flex-start")};
    .entityName {
      display: none;
    }
  }
`;

const DisplayElementContainer = styled.div`
  display: flex;
  overflow: hidden;
  flex-wrap: wrap;
  color: #908f96;
  font-size: 13px;
  text-decoration: underline;
  margin-left: -10px;
  margin-bottom: -7px;
`;

const DisplayElementLink = styled.div`
  margin: 0 5px;
  padding: 5px;
  text-transform: capitalize;
  opacity: 0.8;
  white-space: nowrap;
  box-sizing: border-box;
  cursor: pointer;
  &:hover {
    opacity: 1;
    color: #222222 !important;
  }
`;

export const ArrowPrev = props => (
  <div {...props}>
    <NavArrow>
      <NavigateBeforeIcon />
    </NavArrow>
  </div>
);

export const ArrowNext = props => (
  <div {...props}>
    <NavArrow>
      <NavigateNextIcon />
    </NavArrow>
  </div>
);

const SliderContainer = styled.div`
  width: 100%;
  height: 100%;
  .slick-slider {
    position: relative !important;
  }
`;

const ImageContainer = styled.div`
  width: 100%;
  height: 100%;
  div,
  img,
  aside {
    width: 131px !important;
    height: 84px !important;
    ${media.up.md`
      width: 252px !important;
      height: 158px !important;

  `};
  }
`;

const StyledTaxesIncludedFeesExcluded = styled.div`
  font-size: 12px;
  font-weight: 400;
  font-style: italic;
  line-height: 16px;
  color: #8f8f8f;
  text-align: right;

  @media only screen and (max-width: 700px) {
    padding-top: 1em;
  }
`;

function createSliderSetting({ mediaLength, renderArrows }) {
  return {
    arrows: mediaLength > 1 && renderArrows,
    autoplay: false,
    centerMode: false,
    infinite: true,
    lazyLoad: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    swipe: true,
    nextArrow: (
      <ArrowContainer>
        <ArrowNext />
      </ArrowContainer>
    ),
    prevArrow: (
      <ArrowContainer>
        <ArrowPrev />
      </ArrowContainer>
    ),
  };
}

const msgs = defineMessages({
  readMore: {
    id: "room_selection.entity.readMore",
    description: "Read more",
    defaultMessage: "Read more",
  },
  from: {
    id: "room_selection.entity.from",
    description: "From",
    defaultMessage: "from",
  },
  night: {
    id: "room_selection.entity.night",
    description: "Night",
    defaultMessage: "night",
  },
  select: {
    id: "room_selection.entity.select",
    description: "Select",
    defaultMessage: "Select",
  },
  view: {
    id: "room_selection.entity.view",
    description: "View button",
    defaultMessage: "Ver",
  },
  unavailable: {
    id: "room_selection.entity.agotada",
    description: "agotada",
    defaultMessage: "Sold Out",
  },
  restricted: {
    id: "room_selection.entity.restricted",
    description: "restricted",
    defaultMessage: "Restricted",
  },
  seeAvailability: {
    id: "room_selection.entity_carousel.seeAvailability",
    description: "seeAvailability",
    defaultMessage: "view availabilty",
  },
  seeOptions: {
    id: "room_selecton.entity.seeOptions",
    description: "seeOptions",
    defaultMessage: "view options",
  },
  info: {
    id: "contextualdisplay.info",
    description: "Info tab",
    defaultMessage: "Info",
  },
  map: {
    id: "contextualdisplay.map",
    description: "Map tab",
    defaultMessage: "Map",
  },
  availability: {
    id: "contextualdisplay.availability",
    description: "Availability tab",
    defaultMessage: "Not available for",
  },
  TAXES_INCLUDED_FEES_EXCLUDED: {
    id: "checkout.booking_total.VatIncludedTaxesExcluded",
    description: "Taxes included / city tax excluded",
    defaultMessage: "Taxes included / city tax excluded",
  },
  TAXES_AND_FEES_INCLUDED: {
    id: "checkout.booking_total.VatAndTaxesIncluded",
    description: "Taxes and fees included",
    defaultMessage: "Taxes and fees included",
  },
});

function getStatusDetails(
  status,
  type,
  value,
  labelClassName,
  failedValueClassName,
  successValueClassName
) {
  if (!status) {
    return null;
  }
  return {
    status: status,
    valueType: type,
    value: value,
    labelClassName: labelClassName,
    valueClassName:
      status === constants.BOOKABLE_STATUS.AVAILABLE ? successValueClassName : failedValueClassName,
  };
}

function renderTranslatedDisplayLabel(label) {
  switch (label) {
    case constants.DISPLAY_ELEMENT_TYPE.INFO:
      return <FormattedMessage {...msgs.info} />;
    case constants.DISPLAY_ELEMENT_TYPE.MAP:
      return <FormattedMessage {...msgs.map} />;
    case constants.DISPLAY_ELEMENT_TYPE.AVAILABILITY:
      return <FormattedMessage {...msgs.availability} />;
    default:
      return label;
  }
}

function handleDisplayElements(displayElements, containerElements, name) {
  if (containerElements && containerElements.current) {
    const containerElementsWidth = containerElements.current.offsetWidth;
    let total = 0;
    displayElements.forEach((e, index) => {
      const elementName = `element-${name}-${index}`;
      const element = document.getElementById(elementName);
      if (element) {
        document.getElementById(elementName).style.display = "flex";
        const elementWidth = element.offsetWidth || 0;
        if (elementWidth && total + elementWidth > containerElementsWidth) {
          document.getElementById(elementName).style.display = "none";
        }
        total = total + elementWidth;
      }
    });
  }
}

const EntityUniversal = ({
  name,
  description,
  currency,
  minPrice,
  medias,
  thumbnail,
  thumbnailTitle,
  hasImage,
  onExpand,
  statusCode,
  statusFilterType,
  statusValue,
  isAvailable,
  windowWidth,
  handleGallery,
  displayElements,
  onDisplayElementClick,
  showDisplayElements,
  containerElements,
  loyalty,
  loyaltyRate,
  deviceType,
  userLoyaltyTier,
  handleModalContent,
  handleCloseModal,
  linkToLoyaltyLogin,
  occupants,
  locale,
  entityTicker,
  taxesText,
}) => {
  const nameWithoutSpace = name.replace(/\s/g, "");

  const WIT_UNAVAILABLE_ROOM_QUERY_HOTEL_MESSAGE =
    window.WIT_UNAVAILABLE_ROOM_QUERY_HOTEL_MESSAGE || {};
  const WIT_UNAVAILABLE_ROOM_QUERY_HOTEL = [...(window.WIT_UNAVAILABLE_ROOM_QUERY_HOTEL || [])];

  const showUnavailableRoomQueryMessage =
    statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE &&
    WIT_UNAVAILABLE_ROOM_QUERY_HOTEL.includes(entityTicker);

  let textUnavailableRoom = "";
  if (WIT_UNAVAILABLE_ROOM_QUERY_HOTEL_MESSAGE[locale]) {
    textUnavailableRoom = WIT_UNAVAILABLE_ROOM_QUERY_HOTEL_MESSAGE[locale]
      .replace("{{checkin}}", window.wbkStartDate)
      .replace("{{checkout}}", window.wbkEndDate)
      .replace("{{adult}}", occupants.ADULT)
      .replace("{{junior}}", occupants.TEENAGER)
      .replace("{{child}}", occupants.CHILD)
      .replace("{{baby}}", occupants.BABY)
      .replace("{{room}}", entityTicker);
  }
  const isTaxesTextShowable =
    taxesText && statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE;
  handleDisplayElements(displayElements, containerElements, nameWithoutSpace);

  return (
    <div
      className={classnames("wbkv9-Entity-container", styles.entityContainer, {
        [styles.available]:
          (statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE) || isAvailable,
        [styles.restricted]: statusCode && statusCode === constants.BOOKABLE_STATUS.RESTRICTED,
        [styles.unavailable]: statusCode && statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE,
      })}>
      <div className={classnames("wbkv9-Entity-wrapper", styles.entityWrapper)}>
        <div className={classnames("wbkv9-Entity-detailContainer", styles.detailContainer)}>
          <div className={classnames("wbkv9-Entity-thumbnailContainer", styles.thumbnailContainer)}>
            <SliderContainer
              className={classnames("wbkv9-EntityCarousel-imageSlider")}
              onClick={event => {
                event.stopPropagation();
              }}>
              {medias.length >= 1 && (
                <Slider
                  {...createSliderSetting({
                    mediaLength: medias.length,
                    renderArrows: windowWidth > 767,
                  })}>
                  {medias.map(media => (
                    <div
                      key={media.url}
                      className={classnames("wbkv9-Entity-thumbnail", styles.thumbnail)}
                      onClick={handleGallery}>
                      <ImageContainer>
                        <Thumbnail src={media.url} onHover={() => null} title={thumbnailTitle} />
                      </ImageContainer>
                    </div>
                  ))}
                </Slider>
              )}
              {medias.length <= 0 && (
                <div
                  className={classnames("wbkv9-Entity-thumbnail", styles.thumbnail)}
                  onClick={handleGallery}>
                  <ImageContainer>
                    <Thumbnail src={thumbnail} onHover={() => null} title={thumbnailTitle} />
                  </ImageContainer>
                </div>
              )}
            </SliderContainer>
          </div>
          <div className={classnames("wbkv9-Entity-infoContainer", styles.infoContainer)}>
            <InfoWrapper
              showDisplayElements={showDisplayElements}
              className={classnames("wbkv9-Entity-infoWrapper", styles.infoWrapper)}>
              <div className={classnames("wbkv9-Entity-name", styles.entityName)}>{name}</div>
              <DescriptionContainer
                className={classnames(
                  "wbkv9-Entity-descriptionContainer",
                  styles.descriptionContainer
                )}>
                {showUnavailableRoomQueryMessage && (
                  <span dangerouslySetInnerHTML={renderHTML(textUnavailableRoom)} />
                )}
                <div className={classnames("wbkv9-Entity-description", styles.entityDescription)}>
                  <span dangerouslySetInnerHTML={renderHTML(description)} />
                </div>
                {!showDisplayElements && (
                  <div className={classnames("wbkv9-Entity-readMore", styles.readMore)}>
                    <span>
                      <FormattedMessage {...msgs.readMore} />
                    </span>
                  </div>
                )}
              </DescriptionContainer>

              {showDisplayElements && (
                <DisplayElementContainer ref={containerElements}>
                  {displayElements.map((element, idx) => (
                    <DisplayElementLink
                      id={`element-${nameWithoutSpace}-${idx}`}
                      key={idx}
                      onClick={event => onDisplayElementClick({ event, element })}>
                      {renderTranslatedDisplayLabel(element.label)}
                    </DisplayElementLink>
                  ))}
                </DisplayElementContainer>
              )}
            </InfoWrapper>
            <div
              className={classnames(
                "wbkv9-Entity-ariContainer",
                statusCode &&
                  (statusCode === constants.BOOKABLE_STATUS.RESTRICTED ||
                    statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE) &&
                  "wbkv9-Entity-ariContainer-notAvailable",
                styles.ariContainer,
                statusCode &&
                  (statusCode === constants.BOOKABLE_STATUS.RESTRICTED ||
                    statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE) &&
                  styles.notAvailable
              )}>
              <div className={classnames("wbkv9-Entity-name", styles.entityName)}>{name}</div>

              {loyalty && statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE && (
                <Tier
                  {...loyalty}
                  deviceType={deviceType}
                  price={loyaltyRate}
                  userLoyaltyTier={userLoyaltyTier}
                  handleModalContent={handleModalContent}
                  handleCloseModal={handleCloseModal}
                  linkToLoyaltyLogin={linkToLoyaltyLogin}
                />
              )}
              {((statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE) ||
                isAvailable) && (
                <div className={classnames("wbkv9-Entity-amountContainer", styles.amountContainer)}>
                  <div
                    className={classnames(
                      "wbkv9-Entity-amountLabelContainer",
                      styles.amountLabelContainer
                    )}>
                    <div
                      className={classnames(
                        "wbkv9-Entity-amountCurrencyLabel",
                        styles.amountCurrencyLabel
                      )}>
                      {currency}
                    </div>

                    <div className={classnames("wbkv9-Entity-nightsLabel", styles.nightsLabel)}>
                      <FormattedMessage {...msgs.night} />
                    </div>
                  </div>

                  <div className={classnames("wbkv9-Entity-amount", styles.amount)}>
                    <Amount amount={minPrice} />
                  </div>
                </div>
              )}

              {statusCode && statusCode === constants.BOOKABLE_STATUS.RESTRICTED && (
                <div
                  className={classnames(
                    "wbkv9-Entity-restrictedLabel",
                    "wbkv9-Entity-availabilityLabel",
                    styles.restrictedLabel,
                    styles.availabilityLabel
                  )}>
                  <BookableErrorMessage
                    {...getStatusDetails(
                      statusCode,
                      statusFilterType,
                      statusValue,
                      styles.statusLabel,
                      styles.failed,
                      styles.passed
                    )}
                    hotelCard
                  />
                </div>
              )}

              {statusCode && statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE && (
                <div
                  className={classnames(
                    "wbkv9-Entity-unavailableLabel",
                    "wbkv9-Entity-availabilityLabel",
                    styles.unavailableLabel,
                    styles.availabilityLabel
                  )}>
                  <FormattedMessage {...msgs.unavailable} />
                </div>
              )}

              <div
                className={classnames("wbkv9-Entity-buttonWrapper", styles.buttonWrapper)}
                onClick={onExpand}>
                {((statusCode && statusCode === constants.BOOKABLE_STATUS.AVAILABLE) ||
                  isAvailable) && (
                  <button className={classnames("wbkv9-Entity-button", styles.button)}>
                    <FormattedMessage {...msgs.view} />
                  </button>
                )}

                {statusCode && statusCode === constants.BOOKABLE_STATUS.RESTRICTED && (
                  <div className={classnames("wbkv9-Entity-buttonLink", styles.buttonLink)}>
                    <FormattedMessage {...msgs.seeOptions} />
                  </div>
                )}

                {statusCode === constants.BOOKABLE_STATUS.UNAVAILABLE && (
                  <div className={classnames("wbkv9-Entity-buttonLink", styles.buttonLink)}>
                    <FormattedMessage {...msgs.seeOptions} />
                  </div>
                )}
              </div>
              {isTaxesTextShowable && (
                <StyledTaxesIncludedFeesExcluded>
                  <FormattedMessage {...msgs[taxesText]} values={{ taxes: null, fees: null }} />
                </StyledTaxesIncludedFeesExcluded>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

class EntityCarousel extends Component {
  constructor(props) {
    super(props);
    this.containerElements = React.createRef();
  }

  onExpandRoom(ticker, elem, displayElementTicker) {
    return this.props.onSelect({
      ...elem,
      accommodation: ticker,
      displayElementTicker,
    });
  }

  handleGallery = (element, ticker, propertyTicker, onExpand, type, event) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    if (!element || !element.media) {
      return;
    }

    this.props.handleGallery(
      element.media,
      element.title,
      element.description,
      { propertyTicker, inventoryTicker: ticker },
      onExpand,
      type
    );
  };

  handleDisplayElementClick = ({ event, ticker, entity, element }) => {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.onExpandRoom(ticker, entity, element.ticker);
  };

  render() {
    const {
      occupants,
      entities,
      type,
      propertyTicker,
      windowWidth,
      displayElements,
      propertyFiltersShown,
      loyalty,
      deviceType,
      userLoyaltyTier,
      handleModalContent,
      handleCloseModal,
      linkToLoyaltyLogin,
      locale,
      taxesText,
    } = this.props;
    const Elem =
      entities.size > 0
        ? entities.map((entity, idx) => {
            if (entity.size) {
              entity = entity.toJS();
            }
            const onExpand = this.onExpandRoom.bind(this, entity.ticker, entity, "");
            const onDisplayElementClick = ({ event, element }) =>
              this.handleDisplayElementClick({
                event,
                ticker: entity.ticker,
                entity,
                element,
              });
            const ticker = type === "accommodation" ? entity.ticker : null;

            const tickerFilter = filterDisplayElement({
              activeEntity: { ticker: entity.ticker },
              isPropertyChain: false,
              type: constants.DISPLAY_CONDITION_TYPE.TICKER,
            });

            return (
              <EntityUniversal
                key={idx}
                containerElements={this.containerElements}
                name={entity.title}
                description={entity.description}
                currency={entity.currency}
                minPrice={entity.minPrice}
                medias={entity.media}
                thumbnail={entity.thumbnail}
                thumbnailTitle={entity.media && entity.media[0] && entity.media[0].title}
                hasImage={entity.hasImage}
                statusCode={entity.statusCode}
                statusFilterType={entity.statusFilterType}
                statusValue={entity.statusValue}
                isAvailable={entity.isAvailable}
                onExpand={onExpand}
                handleGallery={() =>
                  this.handleGallery(entity, ticker, propertyTicker, onExpand, "accommodation")
                }
                windowWidth={windowWidth}
                displayElements={displayElements.filter(tickerFilter)}
                onDisplayElementClick={onDisplayElementClick}
                showDisplayElements={this.props.showDisplayElements}
                loyalty={loyalty}
                loyaltyRate={entity.loyaltyRate}
                deviceType={deviceType}
                userLoyaltyTier={userLoyaltyTier}
                handleModalContent={handleModalContent}
                handleCloseModal={handleCloseModal}
                linkToLoyaltyLogin={linkToLoyaltyLogin}
                occupants={occupants}
                locale={locale}
                propertyTicker={propertyTicker}
                entityTicker={entity.ticker}
                taxesText={taxesText}
              />
            );
          })
        : propertyFiltersShown && (
            <Notification
              className="wbkv9-Notification"
              id={constants.SPECIAL_MESSAGE_TYPES.NO_RESULTS}
              position={constants.MESSAGE_POSITIONS.TOP_INVENTORY_STEP_1}
              type={"error"}
              borderRadius
            />
          );

    return <div>{Elem}</div>;
  }
}

EntityCarousel.propTypes = {
  entities: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  children: PropTypes.array,
  className: PropTypes.string,
  type: PropTypes.string,
  onSelect: PropTypes.func.isRequired,
  windowWidth: PropTypes.number,
  handleGallery: PropTypes.func,
  displayElements: PropTypes.array,
  showDisplayElements: PropTypes.bool,
};

EntityCarousel.defaultProps = {
  displayElements: [],
  onSelect: () => true,
  showDisplayElements: true,
};

function Composed(props) {
  return (
    <div className={"EntityCarousel"}>
      <WidthWrapper>
        <EntityCarousel {...props} />
      </WidthWrapper>
    </div>
  );
}

export default Composed;
